/**
 * A patch instrument extends an instrument's history backwards. An instrument
 * whose own series already reaches back this many years or more does not need
 * one, and every save path refuses a patch on it (`instrument_history_sufficient`).
 * The web dialogs disable "Add patch" on the same rule so the designer is told
 * before trying.
 */
export const PATCH_MAX_INSTRUMENT_HISTORY_YEARS = 10;
